import React from 'react';
import Popover from 'components/Popover';
import tw from 'twin.macro';
import { ShareIcon } from '@heroicons/react/24/outline';
import { Body } from './Body';
import Tooltip2 from '@teetsh/app/src/components/Tooltip2';
import { useTranslation } from 'react-i18next';

export function Share() {
  const { t } = useTranslation(['cahierJournal']);
  return (
    <div>
      <Popover as="div" portal>
        <div>
          <Tooltip2 label={t('cahierJournal:toolbar.share')}>
            <Popover.Button
              icon={ShareIcon}
              className="group"
              minimal
              aria-label="Bouton partage"
            />
          </Tooltip2>
        </div>

        <Popover.Panel overflow="visible" size="auto">
          <div css={[tw`py-4`]}>
            <Body />
          </div>
        </Popover.Panel>
      </Popover>
    </div>
  );
}
